import React from 'react';
import Loadable from "react-loadable";
import { Spin } from 'antd';

const Loading = (loader: any) => {
  return Loadable({
    loader,
    loading: () => {
      return <Spin tip="Loading..." />;
    }
  });
};

const Home = Loading(() => import("../src/Home"));
const Study = Loading(() => import("../src/Study"));
const Search = Loading(() => import("../src/Search"));
const Mine = Loading(() => import("../src/Mine"));
const Course = Loading(() => import("../src/Course"));
const CousrList = Loading(() => import("../src/Home/List"));

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/study',
    component: Study
  },
  {
    path: '/interact',
    component: Search
  },
  {
    path: '/my',
    component: Mine
  },
  {
    path: '/courselist/:typeId',
    component: CousrList
  },
  {
    path: '/course/:id',
    component: Course
  }
]

export default routes;